module.exports = __webpack_public_path__ + "static/colgadas-019-8c975ed30dcd0e6ccb07920d7d419c75.jpg";